/* tslint:disable */

import {ActivityType} from './activity';

export const ALL_USER_COUPON_URL = 'allUserCoupon';

export enum CouponDistributionConditionType {
  distance = 0,
  time = 1,
  groupDistance = 2,
  area = 3,
  calorie = 4,
  specifiedArea = 5,
  // 6 はバックエンドの series（シリーズイベント）が使用中。admin はシリーズイベントを配布条件として扱わないため欠番。再利用禁止。
  activityDays = 7, // 日数チャレンジ（達成日数 >= 閾値でクーポン配布）。BE CouponDistributionConditionType.activityDays と一致
}

export namespace CouponField {
  export type id = number;
  export type race_id = number | null;
  export type created_at = number; // conv
  export type updated_at = number; // conv
  export type title = string;
  export type description = string;
  export type notes = string;
  export type confirmation = string;
  export type expiration_date = number | null;
  export type beginning_distribution_term = number;
  export type end_of_distribution_term = number;
  export type distribution_condition_type = CouponDistributionConditionType;
  export type distribution_condition_value = number;
  export type effective_time = number;
  export type object_shop = string;
  export type use_push_notification = boolean;
  export type push_notification_message = string | null;
  export type qr_code_image_id = string | null;
  export type qr_code_image_filename = string | null;
  export type qr_code_image_content_size = number | null; // conv
  export type qr_code_image_content_type = string | null;
  export type qr_code_image_width = number | null;
  export type qr_code_image_height = number | null;
  export type distribution_all_user_coupon_settings = {
    target_activity_types: ActivityType[];
    target_year_month: number;
  } | null;
}

export interface Coupon {
  id: CouponField.id;
  race_id: CouponField.race_id;
  created_at: CouponField.created_at;
  updated_at: CouponField.updated_at;
  title: CouponField.title;
  description: CouponField.description;
  notes: CouponField.notes;
  confirmation: CouponField.confirmation;
  expiration_date: CouponField.expiration_date;
  beginning_distribution_term: CouponField.beginning_distribution_term;
  end_of_distribution_term: CouponField.end_of_distribution_term;
  distribution_condition_type: CouponField.distribution_condition_type;
  distribution_condition_value: CouponField.distribution_condition_value;
  effective_time: CouponField.effective_time;
  object_shop: CouponField.object_shop;
  use_push_notification: CouponField.use_push_notification;
  push_notification_message: CouponField.push_notification_message;
  qr_code_image_id: CouponField.qr_code_image_id;
  qr_code_image_filename: CouponField.qr_code_image_filename;
  qr_code_image_content_size: CouponField.qr_code_image_content_size;
  qr_code_image_content_type: CouponField.qr_code_image_content_type;
  qr_code_image_width: CouponField.qr_code_image_width;
  qr_code_image_height: CouponField.qr_code_image_height;
  distribution_all_user_coupon_settings?:  CouponField.distribution_all_user_coupon_settings;
}
